import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, ListSubheader, Menu } from '@mui/material';
import React, { useState } from 'react';
import { DOWNLOAD_OPTIONS } from './billsDownload';
import useStyles from './styles';

/**
 * The Bills page's one Download button (LB-6033), in the footer beside the selection's actions. Its menu opens
 * upward, since the footer is at the bottom of the table, and says what it will act on before anything is chosen.
 */
export function BillsDownloadMenu(_ref) {
  let _ref$disabledReason = _ref.disabledReason,
    disabledReason = _ref$disabledReason === void 0 ? null : _ref$disabledReason,
    _ref$isBusy = _ref.isBusy,
    isBusy = _ref$isBusy === void 0 ? false : _ref$isBusy,
    onPick = _ref.onPick,
    scopeLabel = _ref.scopeLabel;
  const classes = useStyles();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchor = _useState2[0],
    setAnchor = _useState2[1];
  const pick = kind => {
    setAnchor(null);
    onPick(kind);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    title: disabledReason || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    size: "small",
    "aria-haspopup": "menu",
    "aria-expanded": Boolean(anchor),
    disabled: Boolean(disabledReason) || isBusy,
    onClick: event => setAnchor(event.currentTarget),
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "file-download"
    }),
    endIcon: /*#__PURE__*/React.createElement("span", {
      className: classes.billsDownloadChevron
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-line-down",
      fontSize: "small"
    })),
    'custom-attribute': 'bills-download'
  }, isBusy ? 'Preparing…' : 'Download')), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchor,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    elevation: 0,
    onClose: () => setAnchor(null),
    open: Boolean(anchor),
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    type: "action-menu"
  }, /*#__PURE__*/React.createElement(ListSubheader, {
    className: classes.billsDownloadScope
  }, scopeLabel), DOWNLOAD_OPTIONS.map(option => /*#__PURE__*/React.createElement(Button, {
    key: option.kind,
    onClick: () => pick(option.kind),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: option.icon
  }), option.label))));
}